import React, { useState, useEffect, useRef } from "react";
import NET from "vanta/dist/vanta.net.min";
import * as THREE from "three";
import styled from "styled-components";
import { breakpoints } from "../../utils/breakpoints";
import arrows from "../../utils/lf30_editor_8n6vqver_arrows.json";
import Lottie from "lottie-react";
import { FadeIn } from "react-slide-fade-in";
import { useOutletContext } from "react-router-dom";
import bg from "../../images/homebtest.png";
import bbb from "../../images/HomepageBanner-mobile.png";

const StyledDiv = styled.div`
	overflow-x: hidden;

	.banner-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 50%;
		height: 100vh;
		justify-content: center;

		.section-btn{
			margin-left: 5px;
		}
		


		.banner-txt {
			width: 80%;
			text-align: left;
			padding: 50px 0;

			.heading {
				color: white;
				font-size: 8vw;
				display: inline-flex;
				font-weight: normal;
			}

			p {
				font: normal normal normal 50px Nexa-Bold;
				color: white;
				padding: 30px 0;
				width: 100%;
				display: inline-flex;
				text-align: left;
				margin-right: auto;
				margin-left: auto;
				justify-content: start;
			}
		}

		.banner-img {
			width: 25vw;
			height: 25vw;
			position: relative;

			img {
				width: 80%;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
	}

	@media screen and ${breakpoints.device.mobileL} {


		.banner-content {
			height: 80vh;
			position: relative;
			width: 100%;
			.banner-txt {
				position: absolute;
			
				text-align: center;
				.heading {
					font-size: 40px;
				
					text-align: center;
				}

				p {
					width: auto;
					font: normal normal normal 22px Nexa-Bold;
					text-align: center
					font-size: 18px;
					padding: 18px 0;
				}
			}
		}
	}
`;

const HomeBanner = () => {
	const [vantaEffect, setVantaEffect] = useState(0);
	const vantaRef = useRef(null);
	const { setIsSubModalOpen } = useOutletContext();

	useEffect(() => {
		try {
			if (!vantaEffect) {
				setVantaEffect(
					NET({
						el: vantaRef.current,
						color: 0xe2964a,
						backgroundAlpha: 0,
						THREE: THREE,
						mouseControls: true,
						touchControls: true,
						gyroControls: false,
						scale: 1.0,
						scaleMobile: 1.0,
						points: 10.0,
						maxDistance:
							window.screen.width >= 500
								? 25.0
								: 15.0,
						spacing:
							window.screen.width >= 500
								? 25.0
								: 20.0,
					})
				);
			}
		} catch (error) {
			console.error("Error initializing Vanta effect:", error);
		}
	
		return () => {
			try {
				if (vantaEffect) vantaEffect.destroy();
			} catch (error) {
				console.error("Error destroying Vanta effect:", error);
			}
		};
	}, [vantaEffect]);

	  const divStyle = window.innerWidth > 750 ? {
            backgroundImage: `url(${bg})`,
            backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width: '100%',
            height: '100vh',
			position: 'relative'
        } : 
		{
            backgroundImage: `url(${bbb})`,
            backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width: '100%',
            height: '80vh',
			position: 'relative'
        }
		;

	
	return (
		<StyledDiv>
			<div style={divStyle} className="vanta-bg">
				<div className="banner-content">
					<div className="banner-txt elite">
						<div className="heading">
							<FadeIn
								from="right"
								delayInMilliseconds={
									250
								}
								positionOffset={
									50
								}
								triggerOffset={
									200
								}>
								L
							</FadeIn>
							<FadeIn
								from="right"
								delayInMilliseconds={
									350
								}
								positionOffset={
									50
								}
								triggerOffset={
									200
								}>
								i
							</FadeIn>
							<FadeIn
								from="right"
								delayInMilliseconds={
									400
								}
								positionOffset={
									50
								}
								triggerOffset={
									200
								}>
								v
							</FadeIn>
							<FadeIn
								from="right"
								delayInMilliseconds={
									450
								}
								positionOffset={
									50
								}
								triggerOffset={
									200
								}>
								e{" "}
							</FadeIn>
							<FadeIn
								from="right"
								delayInMilliseconds={
									650
								}
								positionOffset={
									50
								}
								triggerOffset={
									200
								}>
								{" "}
								&nbsp;S
							</FadeIn>
							<FadeIn
								from="right"
								delayInMilliseconds={
									800
								}
								positionOffset={
									50
								}
								triggerOffset={
									200
								}>
								m
							</FadeIn>
							<FadeIn
								from="right"
								delayInMilliseconds={
									1000
								}
								positionOffset={
									50
								}
								triggerOffset={
									200
								}>
								a
							</FadeIn>
							<FadeIn
								from="right"
								delayInMilliseconds={
									1200
								}
								positionOffset={
									50
								}
								triggerOffset={
									200
								}>
								r
							</FadeIn>
							<FadeIn
								from="right"
								delayInMilliseconds={
									1400
								}
								positionOffset={
									50
								}
								triggerOffset={
									200
								}>
								t
							</FadeIn>
							<FadeIn
								from="right"
								delayInMilliseconds={
									1600
								}
								positionOffset={
									50
								}
								triggerOffset={
									200
								}>
								e
							</FadeIn>
							<FadeIn
								from="right"
								delayInMilliseconds={
									1800
								}
								positionOffset={
									50
								}
								triggerOffset={
									200
								}>
								r
							</FadeIn>
						</div>

						<p
							className="topBannerPara"
							data-aos="fade-up"
							data-aos-delay={1500}
							data-aos-duration={
								1200
							}>
							Enhance Your Lifestyle.
						</p>

						<a href="#home">
							<button
								data-aos="fade-up"
								data-aos-delay={
									1500
								}
								data-aos-duration={
									1200
								}
								onClick={() => {
									setIsSubModalOpen(
										true
									);
								}}
								className="section-btn">
								Get Started
							</button>
						</a>
					</div>

		
				</div>
			</div>
		</StyledDiv>
	);
};

export default HomeBanner;
